import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** User-facing text for caught errors (WebAuthn, network, etc.). */
export function formatUnknownError(error: unknown): string {
  if (error instanceof Error) {
    const msg = error.message.trim();
    return msg || error.name || "Error";
  }
  if (typeof error === "string") return error || "Unknown error";
  if (error != null && typeof error === "object" && "message" in error) {
    const msg = String((error as { message: unknown }).message).trim();
    if (msg) return msg;
  }
  try {
    return String(error);
  } catch {
    return "Unknown error";
  }
}
